{
  "name": "tef-coms",
  "version": "2.24.1",
  "description": "Micro-Frontend of the Consent Management System (COMS)",
  "keywords": [
    "coms",
    "micro-frontend",
    "tef-coms",
    "web component"
  ],
  "license": "INTERNAL USE ONLY",
  "author": {
    "name": "Telefónica Germany GmbH & Co. OHG",
    "email": "u672-coms@telefonica.com"
  },
  "repository": {
    "type": "git",
    "url": "https://mucsggit02.sg.de.pri.o2.com/consent-management/consent-management.git",
    "directory": "micro-frontend"
  },
  "files": [
    "dist/**/*"
  ],
  "type": "module",
  "module": "dist/tef-coms.js",
  "types": "dist/typings.d.ts",
  "publishConfig": {
    "registry": "https://art02.sg.de.pri.o2.com/artifactory/api/npm/npm-local/"
  },
  "scripts": {
    "install:ci": "npm ci --no-audit --no-fund",
    "postinstall:ci": "echo '> npm ci in dependency projects:';node --eval 'console.log(require(\"./tsconfig.json\").references.map(r=>r.path).join(\"\\n\"));' | xargs -I{} sh -c 'cd {}; pwd; npm run install:ci'",
    "dev": "tsx scripts/esbuild/dev.ts",
    "dev:docker": "npm run build && npm run dev",
    "build": "npm run build:ts && npm run build:docs",
    "build:ts": "tsx scripts/esbuild/build.ts",
    "build:docs": "tsx scripts/create-docs.ts",
    "build:serve": "npm run build && npx -y serve -l 4400 dist",
    "lint": "lit-analyzer && eslint .",
    "lint:fix": "eslint . --fix",
    "test": "npm run test:browser && npm run test:unit",
    "test:browser": "web-test-runner",
    "test:unit": "vitest run",
    "test:verbose": "npm run test:unit -- --reporter verbose",
    "test:all": "npm run lint && npm run build:ts && npm test",
    "test:ci": "npm run lint && CI=true npm test && npm run test:zipcov",
    "test:ci-reduced": "npm run lint && CI=true npm test",
    "preversion": "npm run lint && npm test",
    "test:zipcov": "zip lcov.zip ./coverage-unit/lcov.info ./coverage-browser/lcov.info"
  },
  "dependencies": {
    "lit": "^3.3.1",
    "nanoid": "^5.1.6",
    "pwa-helpers": "^0.9.1",
    "redux": "^5.0.1",
    "redux-thunk": "^3.1.0",
    "regenerator-runtime": "^0.14.1",
    "unfetch": "^5.0.0"
  },
  "devDependencies": {
    "@open-wc/testing": "^4.0.0",
    "@rollup/plugin-replace": "^6.0.2",
    "@types/jsonwebtoken": "^9.0.10",
    "@types/markdown-it": "^14.1.2",
    "@types/markdown-it-attrs": "^4.1.3",
    "@types/markdown-it-container": "^4.0.0",
    "@types/markdown-it-emoji": "^3.0.1",
    "@types/mocha": "^10.0.10",
    "@types/mustache": "^4.2.6",
    "@types/redux-mock-store": "^1.5.0",
    "@types/sinon": "^21.0.0",
    "@vitest/coverage-v8": "^4.1.1",
    "@web/dev-server-esbuild": "^1.0.5",
    "@web/test-runner": "^0.20.2",
    "@web/test-runner-puppeteer": "^0.18.0",
    "esbuild": "^0.27.3",
    "esbuild-plugin-copy": "^2.1.1",
    "eslint": "^8.57.1",
    "eslint-config-airbnb-base": "^15.0.0",
    "eslint-config-airbnb-typescript": "^18.0.0",
    "eslint-import-resolver-typescript": "^3.7.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-lit": "^1.15.0",
    "eslint-plugin-promise": "^7.2.1",
    "eslint-plugin-sonarjs": "^4.0.1",
    "fetch-mock": "^12.5.4",
    "finalhandler": "^2.1.0",
    "happy-dom": "^20.8.8",
    "jsdom": "^28.1.0",
    "jsonwebtoken": "^9.0.2",
    "lit-analyzer": "^2.0.3",
    "markdown-it": "^14.1.1",
    "markdown-it-anchor": "^9.2.0",
    "markdown-it-attrs": "^4.3.1",
    "markdown-it-container": "^4.0.0",
    "markdown-it-emoji": "^3.0.0",
    "markdown-it-toc-done-right": "^4.2.0",
    "mdn-polyfills": "^5.20.0",
    "mustache": "^4.2.0",
    "puppeteer": "^24.37.5",
    "redux-mock-store": "^1.5.5",
    "rollup-plugin-typescript-paths": "^1.5.0",
    "sinon": "^21.0.0",
    "ts-node": "^10.9.2",
    "ts-patch": "^3.3.0",
    "tsconfig-paths": "^4.2.0",
    "tsx": "^4.20.6",
    "typescript": "^5.9.2",
    "typescript-eslint": "^8.44.1",
    "typescript-transform-paths": "^3.5.5",
    "vite": "^8.0.2",
    "vitest": "^4.1.2",
    "vue": "^3.5.34",
    "vuetify": "^4.0.7"
  },
  "overrides": {
    "@typescript-eslint/parser": "^7.18.0",
    "@typescript-eslint/typescript-estree": "^8.44.0"
  },
  "title": "COMS Micro-Frontend"
}
